export default "__VITE_ASSET__T9fYBhmd__"